//console
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../components/helpers/Axios";
export const saveProfile=createAsyncThunk("profile/save",async({values,onNext,lastStep,setIsDialogOpen,navigate,setStateSnackbarContext},{rejectWithValue})=>{
try {
     const res=await axios.post("/profile/save",values)
      if(res.status===200){
        if(lastStep){
            // setIsDialogOpen(true) console
            navigate("/events")
            setStateSnackbarContext( true,
        `Details Saved successfully`,
        "success")
          }else{
            onNext()
          }
        
      }
     return res.data.wedding
} catch (error) {
     return rejectWithValue(error.response.data.message) 
}
})

export const uploadMusic=createAsyncThunk("music/upload",async({payload,setStateSnackbarContext,setUploadedMusic, setMusic},{rejectWithValue})=>{
    try {
         const res=await axios.post("/profile/music",payload)
         setStateSnackbarContext(
        true,
        `Music uploaded successfully`,
        "success"
      )
         return res.data.wedding
    } catch (error) {
         return rejectWithValue(error.response.data.message) 
    }
})

export const deleteMusic=createAsyncThunk("music/delete",async({ setStateSnackbarContext})=>{
    try {
        const res=await axios.get("/profile/music/delete") 
         setStateSnackbarContext(
        true,
        `Music removed successfully`,
        "success"
      ) 
        return res.data.wedding
    } catch (error) {
    //    console.log(error)  
    }
})

export const deleteGallery=createAsyncThunk("gallery/delete",async({setStateSnackbarContext})=>{
    try {
         const res=await axios.get("/profile/gallery/delete") 
          setStateSnackbarContext(
        true,
        `Gallery removed successfully`,
        "success"
      ) 
      return res.data.wedding
    } catch (error) {
        //   console.log(error)  
    }
})

export const selectPresetMusic=createAsyncThunk("music/preset",async({ presetId,url,setStateSnackbarContext},{rejectWithValue})=>{
     
    let payload={
        presetId,
        url
    }
    try {
        const res=await axios.post("/profile/music/preset",payload) 
        setStateSnackbarContext(
        true,
        `Background music updated`,
        "success"
      )
         return res.data.wedding
    } catch (error) {
      return rejectWithValue(error.response.data.message) 
    }
})

export const getProfile=createAsyncThunk("profile/details",async(data,{rejectWithValue})=>{
  try {
    const res=await axios.get("/profile/details")
    return res.data.wedding
  } catch (error) {

     return rejectWithValue(error.response.data.message) 
  }
})

export const uploadAlbum=createAsyncThunk("album/upload",async({formdata,setShowBackDrop,handleCropper,setStateSnackbarContext,setValues,values},{rejectWithValue})=>{
try {
    const config={headers:{"Content-Type":"multipart/form-data"}}
    const res=await axios.post(`/profile/upload/album`,formdata,config)
    setShowBackDrop(false)
    setValues({
        ...values,
        footerImages:res.data.wedding.footerImages 
    })
    handleCropper()
    setStateSnackbarContext(
        true,
        `image  upload success`,
        "success"
      )
      return res.data.wedding
} catch (error) {
    return rejectWithValue(error.response.data.message) 
}
})

export const deleteAlbum=createAsyncThunk("banner/delete",async({id,handleClose},{rejectWithValue})=>{
    try {
        const res=await axios.post(`/profile/delete/album`,{id})

     handleClose()
     return res.data.wedding
    } catch (error) {
        return rejectWithValue(error.response.data.message)   
    }
})

export const reorderAlbum=createAsyncThunk("album/reorder",async({updatedImages},{rejectWithValue})=>{
    try {
         const res=await axios.post(`/profile/album/reorder`,updatedImages)
         return res.data.wedding
        } catch (error) {
        return rejectWithValue(error.response.data.message)   
     }
})

export const uploadBanner=createAsyncThunk("banner/upload",async({formdata,fieldName,handleCropper,setValues,values,setShowBackDrop,setStateSnackbarContext},{rejectWithValue})=>{
   try {
    const config={headers:{"Content-Type":"multipart/form-data"}}
    const res=await axios.post(`/profile/${fieldName}/upload`,formdata,config)
    setShowBackDrop(false)
   setValues({
        ...values,
        [fieldName]:{
            url:res.data.wedding[fieldName].url,
            public_id:res.data.wedding[fieldName].public_id
        }
    })
   
    handleCropper()
    setStateSnackbarContext(
        true,
        `${fieldName}  upload success`,
        "success"
      )
    return res.data.message
   } catch (error) {

    return rejectWithValue(error.response.data.message) 
   }
})


export const getProfileDetail=createAsyncThunk("profile/detail/id",async({id,navigate,setStateSnackbarContext,setNotFound,isPreview = false},{rejectWithValue})=>{
try {
    const res=await axios.get(`/profile/details/${id}?preview=${isPreview}`)
     return res.data.wedding
} catch (error) {
    if(error.response.data.message==="Please Sign up first"){
        navigate(`/signup/${id}`)
        setStateSnackbarContext(
            true,
            "Please Signup",
            "warning"
        )
    }
   
    return rejectWithValue(error.response.data.message) 
}
})

export const setNewTheme=createAsyncThunk("profile/newtheme",async({themeId,navigate,setStateSnackbarContext},{rejectWithValue})=>{
    try {
        const res=await axios.post("/profile/theme",{themeId})
          setStateSnackbarContext(
            true,
            "Theme Changed Success",
            "success"
        )
        return res.data.wedding
    } catch (error) {
        if(error.response.data.message==="invalid theme"){
           navigate("/sample-themes")
        }
        return rejectWithValue(error.response.data.message) 
    }
})





const profileSlice=createSlice({
    name:"profile",
    initialState:{
        loading:false,
        weddingData:{},
        error:null,
         profileLoaded: false,
        message:""
    },
    reducers:{
        clearError:(state)=>{
            state.error=null;
         }
    },
    extraReducers:(builder)=>{
        builder
        .addCase(saveProfile.pending,(state)=>{
            state.loading=true
        })
        .addCase(saveProfile.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(saveProfile.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        .addCase(getProfile.pending,(state)=>{
            state.loading=true
        })
        .addCase(getProfile.fulfilled,(state,action)=>{
            state.loading=false;
                state.profileLoaded = true;
            state.weddingData=action.payload
        })
        .addCase(getProfile.rejected,(state,action)=>{
            state.loading=false;
                state.profileLoaded = true;
            state.error=action.payload
        })

        .addCase(uploadBanner.pending,(state)=>{
            state.loading=true
        })
        .addCase(uploadBanner.fulfilled,(state,action)=>{
            state.loading=false;
            state.message=action.payload
        })
        .addCase(uploadBanner.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        .addCase(getProfileDetail.pending,(state)=>{
            state.loading=true
        })
        .addCase(getProfileDetail.fulfilled,(state,action)=>{
            state.loading=false;
                state.profileLoaded = true;
            state.weddingData=action.payload
        })
        .addCase(getProfileDetail.rejected,(state,action)=>{
            state.loading=false;
                state.profileLoaded = true;
            state.error=action.payload
        })

        .addCase(uploadAlbum.pending,(state)=>{
            // state.loading=true
        })
        .addCase(uploadAlbum.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(uploadAlbum.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })
        .addCase(deleteAlbum.pending,(state)=>{
            // state.loading=true
        })
        .addCase(deleteAlbum.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(deleteAlbum.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        .addCase(reorderAlbum.pending,(state)=>{
            // state.loading=true
        })
        .addCase(reorderAlbum.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(reorderAlbum.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })
        
        .addCase(setNewTheme.pending,(state)=>{
            state.loading=true
        })
        .addCase(setNewTheme.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(setNewTheme.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        .addCase(uploadMusic.pending,(state)=>{
            state.loading=true
        })
        .addCase(uploadMusic.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(uploadMusic.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

            .addCase(deleteMusic.pending,(state)=>{
            state.loading=true
        })
        .addCase(deleteMusic.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(deleteMusic.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

         .addCase(deleteGallery.pending,(state)=>{
            state.loading=true
        })
        .addCase(deleteGallery.fulfilled,(state,action)=>{
            state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(deleteGallery.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

          .addCase(selectPresetMusic.pending,(state)=>{
            // state.loading=true
        })
        .addCase(selectPresetMusic.fulfilled,(state,action)=>{
            // state.loading=false;
            state.weddingData=action.payload
        })
        .addCase(selectPresetMusic.rejected,(state,action)=>{
            // state.loading=false;
            state.error=action.payload
        })
        
    }
})

export const {clearError}=profileSlice.actions

export default profileSlice.reducer